Librarian.ChangeDateWindow = new Class({
    Extends: Librarian.Window,
    Binds: ["changeDate"],

    options: {
        id: "ChangeDateWindow",
        height: 120,
        width: 300,
        allowNever: false,
        initialValue: null
    },

    datePicker: null,
    onSubmit: null,

    initialize: function(options) {
        this.setOptions(options);

        // Set the title on init so that we can use the localization
        this.options.title = Librarian.Lang.getString("date_title");

        this.onSubmit = options.onSubmit;
        this.options.contentURL = Librarian.path.getLayoutsPath() + "pages/changedate.html";

        this.parent(this.options);
    },

    onWindowLoaded: function() {
        this.parent();

        var itemEl = $("changeDateBox");
        if (itemEl) {
            if (this.options.initialValue)
                Librarian.Utils.setElementValue(itemEl, Librarian.Utils.extractDateFromString(this.options.initialValue).format("%m/%d/%Y %I:%M %p"));

            // If the changeDateBox is clicked, check the radio button for 'Date' and set the current date
            itemEl.addOnClick(function() {
                var dateRadioEl = $("changeDateRadio");
                if (dateRadioEl) {
                    dateRadioEl.set("checked", true);
                    var dateBoxEl = $("changeDateBox"),
                        dateValue = Librarian.Utils.getElementValue(dateBoxEl) || '';
                    if (dateValue.length == 0)
                        Librarian.Utils.setElementValue(dateBoxEl, this.getTodayDateString());
                }
            }, this);
        }

        // When the 'Date' radio button is selected, auto-fill the current date
        if (this.options.allowNever) {
            itemEl = $("changeDateRadio");
            if (itemEl) {
                itemEl.show();
                itemEl.addOnClick(function() {
                    var dateBoxEl = $("changeDateBox"),
                        dateValue = Librarian.Utils.getElementValue(dateBoxEl) || '';
                    if (dateValue.length == 0)
                        Librarian.Utils.setElementValue(dateBoxEl, this.getTodayDateString());
                }, this);
            }

            itemEl = $("changeDateNeverLabel");
            if (itemEl)
                itemEl.show();

            // If the date is already set to never expire, open the window with never selected
            itemEl = $("changeDateNeverRadio");
            if (itemEl) {
                if (!this.options.initialValue)
                    itemEl.set("checked", true);

                // Clear the Date Box when 'Never' is selected
                itemEl.addOnClick(function() {
                    Librarian.Utils.setElementValue($("changeDateBox"), '');
                });
            }
        }

        itemEl = $("changeDateCancelButton");
        if (itemEl)
            itemEl.addEvent("click", this.close);

        itemEl = $("changeDateOKButton");
        if (itemEl)
            itemEl.addEvent("click", this.changeDate);

        this.datePicker = Librarian.Utils.setUpDatePicker("changedate", "changeDateBox", "changeDateIcon", "",
            function() {
                if (this.datePicker) {
                    this.datePicker.close();
                }
                itemEl = $("changeDateRadio");
                //Select the 'Date' radio button when clicking on the calendar icon and fill in the current date
                if (itemEl)
                    itemEl.set("checked", true);
                var dateBox = $("changeDateBox");
                if (dateBox && (!dateBox.get("value") || dateBox.get("value") == ""))
                    dateBox.set("value", this.getTodayDateString());
            }.bind(this), {
                timePicker: true
            }
        );
    },

    changeDate: function() {
        var newDate = '';

        var dateEl = $("changeDateBox");
        var radioEl = $("changeDateRadio");
        if (dateEl && radioEl && radioEl.checked)
            newDate = dateEl.value;

        if (typeof this.onSubmit == "function")
            this.onSubmit(newDate);

        this.close();
    },

    //Get the current date correctly formatted
    getTodayDateString: function() {
        var d = new Date(),
            dateStr = "",
            date;
        //Month is returned 0 base
        dateStr += ((date = d.getMonth() + 1) < 10) ? "0" : "";
        dateStr += date + "/";
        dateStr += ((date = d.getDate()) < 10) ? "0" : "";
        dateStr += date + "/" + d.getFullYear();

        return dateStr;
    },

    onClose: function() {
        if (this.datePicker)
            this.datePicker.close();

        this.parent();
    }
});
